export const ROUTER = {
    // -- 首页tab  Begin --
    PROFILE: '/profile', // 个人中心
    MY_LIST: '/my-list', // 我的书架
    DISCOVER: '/discover', // 发现
    // -- 首页tab  End --

    LOGIN: '/login', // 登录

    READER: '/reader', // 阅读器

    // -- 个人中心 二级页  Begin --
    WALLET: '/wallet', // 钱包
    TOP_UP: '/top-up', // 充值记录
    SETTINGS: '/settings', // 设置
    FEEDBACK: '/feedback', // 反馈
    PAY: '/pay', // 充值
    CONSUMPTION: '/consumption', // 消费记录
    // -- 个人中心 二级页  End --
};
